import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3833194a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw" }

export function render(_ctx, _cache) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      "active-key": _ctx.value,
      onChange: _ctx.changeTab
    }, {
      rightExtra: _withCtx(() => [
        _renderSlot(_ctx.$slots, "rightButton", {}, undefined, true)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowStatusArr, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.circulationStatus,
            tab: item.circulationStatusDesc + '(' + item.number + ')'
          }, null, 8, ["tab"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["active-key", "onChange"])
  ]))
}